import type { GeneratedReference, Reference } from "../infrastructure/reference.formatter";

/**
 * @param references
 * @returns Reference[]
 * @description returns generated references (which have databaseGenerated at true)
 */
export function getGeneratedReferences(references: Reference[]): GeneratedReference[] {
  const generatedReferences: GeneratedReference[] = [];
  for (const r of references) {
    if (!r.databaseGenerated || !r.enabled) continue;
    generatedReferences.push({
      ...r,
      databaseGenerated: r.databaseGenerated,
      enabled: r.enabled,
    });
  }
  return generatedReferences;
}

export function getReference(reference: Reference): Reference {
  const databaseGenerated = reference.databaseGenerated;
  if (!databaseGenerated) {
    throw new Error(`Reference with id '${reference.id}' should be generated`);
  }
  return {
    ...reference,
    databaseGenerated,
  };
}
